import React, { Component } from 'react';
import PropTypes from "prop-types";
import WindowSizeListener from "react-window-size-listener";

class Modal extends React.Component {

    state = {
        windowSize: {
            windowHeight: window.clientHeight
        }
    };

    componentWillMount () {
        if(!this.props.bodyScroll && this.props.isOpen){
            document.body.style.overflowY = "hidden";
        }
    }

    componentWillUnmount() {
        if(!this.props.bodyScroll){
            document.body.style.overflowY = "auto";
        }
    }

    onWindowResize = (windowSize) => {
        this.setState({
            windowSize: windowSize
        });
    };

    render() {
        if (this.props.isOpen === false)
            return null;

        const {windowSize} = this.state;

        let containerStyle = {
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            zIndex: '1001',
            overflow: 'auto'
        };

        let modalStyle = {
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            //transform: 'translate(-50%, -50%)',
            zIndex: '1001',
            background: '#fff',
            // overflowY: 'auto',
            // boxShadow:'0 -2px 1px 0 rgba(0,0,0,0.35)',
            borderRadius : '0px'
        };

        if (this.props.width > 0 && this.props.height > 0) {
            modalStyle.width = this.props.width + "%";
            modalStyle.height = this.props.height + "%";

            modalStyle.left = "50%";
            modalStyle.marginLeft = '-' + (this.props.width/2) + "%";

            if(this.props.top){
                modalStyle.top = this.props.top + "%";
            }else{
                modalStyle.top = "50%";
                modalStyle.marginTop = '-' + (this.props.height/2) + "%";
            }
            modalStyle.transform = null;
        }
        if (this.props.widthPx > 0 && this.props.heightPx > 0) {
            modalStyle.width = this.props.widthPx + "px";
            modalStyle.height = this.props.heightPx + "px";

            modalStyle.left = "50%";
            modalStyle.marginLeft = '-' + (this.props.widthPx/2) + "px";

            if(this.props.top){
                modalStyle.top = this.props.top + "%";
            }else{
                modalStyle.top = "50%";
                modalStyle.marginTop = '-' + (this.props.heightPx/2) + "px";
            }
            modalStyle.transform = null;
        }
        if(this.props.width) {
            modalStyle.width = this.props.width;
        }
        if(this.props.widthPx){
            modalStyle.width = this.props.widthPx + "px";
            modalStyle.left = "50%";
            modalStyle.marginLeft = '-' + (this.props.widthPx/2) + "px";
        }

        if (windowSize.windowHeight < this.props.heightPx) {
            modalStyle.top = (this.props.top)? this.props.top: 20;

        }

        if (this.props.maxWidth) {
            modalStyle.maxWidth = this.props.maxWidth;
        }

        if(this.props.maxHeight){
            modalStyle.maxHeight = this.props.maxHeight;
        }
        if (this.props.minWidth) {
            modalStyle.minWidth = this.props.minWidth;
        }

        if(this.props.minHeight){
            modalStyle.minHeight = this.props.minHeight;
        }

        if(this.props.borderRadius){
            modalStyle.borderRadius = this.props.borderRadius;
        }

        if(this.props.top){
            modalStyle.top = this.props.top;
        }

        if (this.props.style) {
            for (let key in this.props.style) {
                modalStyle[key] = this.props.style[key]
            }
        }

        //position: 'absolute'
        let backdropStyle = {
            position: 'fixed',
            width: '100%',
            height: '100%',
            top: '0px',
            left: '0px',
            zIndex: '1000',
            background: 'rgba(0, 0, 0, 0.3)'
        };

        if (this.props.backdropStyle) {
            for (let key in this.props.backdropStyle) {
                backdropStyle[key] = this.props.backdropStyle[key]
            }
        }

        return (
            <div className={this.props.containerClassName}>
                <WindowSizeListener onResize={this.onWindowResize} />
                <div  style={containerStyle}>
                    <div className={this.props.className} style={modalStyle}>
                        {this.props.children}
                    </div>
                </div>
                {!this.props.noBackdrop &&
                <div className={this.props.backdropClassName} style={backdropStyle}
                     onClick={e => this.close(e)}/>}
            </div>
        )
    }

    close(e) {
        e.preventDefault();

        if (this.props.onClose) {
            this.props.onClose()
        }
    }
}

Modal.defaultProps = {
    width: '100%',
    // height: '100%',
    isOpen: false,
    bodyScroll: false
};

Modal.propTypes = {
    top : PropTypes.number,
    width : PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height : PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    widthPx : PropTypes.number,
    heightPx : PropTypes.number
};

export default Modal;


// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js